import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormGroup, FormControl } from 'react-bootstrap'

export const TextInput = (props) => {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: 315
        }}>
        { props.label && <label style={{ alignSelf: 'flex-start'}} > { props.label } </label> }
        { props.questionMark &&
          <div
            data-tip={ props.dataTip }
            style={{
              padding: 5,
              borderRadius: '50%',
              backgroundColor: '#B4B4B4',
              color: 'white',
              width: 20,
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div style={{ color: 'white'}}>
              ?
            </div>
          </div> }
      </div>
      <div>
        <Field
          name={props.inputName}
          component={FormInput}
          inputClass={props.inputClass}
          inputName={props.inputName}
          placeholderText={props.placeholderText}
          bootstrapValidator={props.validate}
          extraClass={props.extraClass}
          required={props.required}
          error={props.error}
          onChange={props.onChange}
          textarea={props.textarea || false}
          type={props.fieldType}
          rows={props.rows}
          disabled={props.disabled}
          errors={props.errors}
        />
      </div>
    </div>
  )
}

class FormInput extends Component {
  render () {
    const { input: { value, onChange } } = this.props

    const error = () => {
      if ( this.props.errors && this.props.errors[this.props.inputName] ) return true
      return false
    }

    return (
      <FormGroup
        className={`${this.props.inputClass} km-formgroup`}
        controlId='formHorizontalEmail'>
        <FormControl
          componentClass={ this.props.textarea ? 'textarea' : 'input' }
          rows={ this.props.rows ? 3 : 1 }
          required={this.props.required || false}
          name={this.props.inputName}
          className={`${this.props.extraClass} ${error() ? 'km-field-error' : 'km-field'}`}
          type={this.props.bootstrapValidator}
          value={value}
          onChange={ value => onChange(value) }
          disabled = { this.props.disabled ? true : false }
          placeholder={ this.props.placeholderText } />
        { this.props.errors && this.props.errors[this.props.inputName] &&
          <div style={{ color: '#FDBF20' }}>
            { this.props.errors[this.props.inputName] }
          </div>
        }
      </FormGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/TextInput.jsx